"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _common = require("../@api/common");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Collapsible = function Collapsible(_ref) {
  var primary = _ref.primary,
    secondary = _ref.secondary,
    tertiary = _ref.tertiary,
    children = _ref.children,
    visibleDefault = _ref.visibleDefault,
    _ref$mainProps = _ref.mainProps,
    mainProps = _ref$mainProps === void 0 ? {} : _ref$mainProps,
    _ref$primaryProps = _ref.primaryProps,
    primaryProps = _ref$primaryProps === void 0 ? {} : _ref$primaryProps,
    _ref$secondaryProps = _ref.secondaryProps,
    secondaryProps = _ref$secondaryProps === void 0 ? {} : _ref$secondaryProps,
    _ref$tertiaryProps = _ref.tertiaryProps,
    tertiaryProps = _ref$tertiaryProps === void 0 ? {} : _ref$tertiaryProps,
    _ref$iconProps = _ref.iconProps,
    iconProps = _ref$iconProps === void 0 ? {} : _ref$iconProps,
    _ref$contentProps = _ref.contentProps,
    contentProps = _ref$contentProps === void 0 ? {} : _ref$contentProps;
  var _useState = (0, _react.useState)(visibleDefault),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var tertiaryHeaderClass = tertiary ? 'tertiary' : '';
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, mainProps, {
    className: "zero-collapsible ".concat(visible ? 'visible' : 'visible', " ").concat(mainProps.className || '')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapsible-header pointer ".concat(tertiaryHeaderClass),
    onClick: function onClick(e) {
      return setVisible(!visible);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapsible-text"
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, primaryProps, {
    className: "primary ".concat(primaryProps.className || '')
  }), primary), /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, secondaryProps, {
    className: "secondary ".concat(secondaryProps.className || '')
  }), secondary)), /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, iconProps, {
    className: "icon ".concat(iconProps.className || '')
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: visible ? 'faCaretDown' : 'faCaretRight'
  }))), tertiary && /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapsible-header tertiary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapsible-text"
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, tertiaryProps, {
    className: "primary ".concat(tertiaryProps.className || '')
  }), tertiary))), !!visible ? /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, contentProps, {
    className: "collapsible-content ".concat(contentProps.className || '')
  }), children) : '');
};
var _default = Collapsible;
exports["default"] = _default;